import { useAppSession } from '@/contexts/SessionContext';
import { useAuth } from '@/hooks/useAuth';
import { useAgentStatus } from '@/hooks/useAgentStatus';
import { useAnonHome } from '@/hooks/useAnonHome';
import type { MobileIslandConfig } from '@/components/ChatInput/types';

export const useMobileIsland = (): MobileIslandConfig => {
  const { session, artifacts } = useAppSession();
  const { chat, chatHistory } = session;
  const auth = useAuth();
  const { onHome, anonPrompt } = useAnonHome();

  const { runningCount } = useAgentStatus(
    chat.activeChatId,
    chat.activeChat?.isRunning,
    chatHistory.sessions,
  );

  return {
    onHome,
    onLogin: auth.signIn,
    isAuthenticated: auth.isAuthenticated,
    runningCount,
    anonPrompt,
    artifactMini: {
      visible: artifacts.hasArtifact && artifacts.mobileArtifactCardMinimized && !artifacts.mobileArtifactOverlay,
      onOpen: () => artifacts.setMobileArtifactOverlay(true),
    },
  };
};
